module.exports = __webpack_public_path__ + "img/logo.ba99da1d.png";